import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/UI/Icon/Icon';
const RedirectToClassPage = ({ gymId, classId }) => {
  const navigate = useNavigate();
  return <Icon name="notes" onClick={() => navigate(`/gym/${gymId}/class/${classId}`)} />;
};

export default RedirectToClassPage;
